import { Base } from "./Base";

export interface Hospital extends Base {
  hospitalName: string;
  hospitalLogoFile: string;
  reportTitle: string;
  reportHasCheckDoctor: boolean;
  reportPrintHospitalName: boolean;
  reportPrintHospitalLogo: boolean;
  reportHospitalLogoAlign: string;
  provinceId: number;
  cityId: number;
  countyId: number;
  provinceName: string;
  cityName: string;
  countyName: string;
}

export const initHospital:Hospital = {
  id: -1,
  key: -1,
  hospitalName: "",
  hospitalLogoFile: "",
  reportTitle: "",
  reportHasCheckDoctor: false,
  reportPrintHospitalName: false,
  reportPrintHospitalLogo: false,
  reportHospitalLogoAlign: "",
  provinceId: -1,
  cityId: -1,
  countyId: -1,
  provinceName: "",
  cityName: "",
  countyName: "",
};
